import { Expose, plainToInstance, Type } from 'class-transformer';

import type { Restaurant } from '@/shared/api/service';

export class RestaurantModel {
  @Expose()
  id: number;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt?: Date;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt?: Date;

  @Expose({ name: 'is_active' })
  isActive?: boolean;

  @Expose()
  name!: string;

  @Expose()
  description?: string;

  @Expose()
  address: string;

  @Expose()
  @Type(() => Number) // приведёт элементы массива к number
  coordinates!: number[]; // [lat, lon]

  @Expose()
  phone?: string;

  @Expose()
  email?: string;

  @Expose({ name: 'working_time' })
  workingTime: Record<
    string,
    { open_at?: string | null; close_at?: string | null }
  > | null = null;

  @Expose()
  image?: string;

  @Expose({ name: 'external_id' })
  externalId?: string;

  @Expose()
  company: number;

  @Expose({ name: 'company_description' })
  companyDescription: string;

  @Expose()
  rating?: number | null;
}

export const plainToInstanceRestaurant = (plain: Restaurant): RestaurantModel =>
  plainToInstance(RestaurantModel, plain, { excludeExtraneousValues: true });
